import { graphql } from "@opensea/graphql"

export const AccountLockupFragment = graphql(`
  fragment AccountLockup on ProfileIdentifier {
    address
    displayName
    imageUrl
  }
`)
